import { render, staticRenderFns } from "./SingleLayerAttributesInfos.vue?vue&type=template&id=0e47df2d&scoped=true"
import script from "./SingleLayerAttributesInfos.vue?vue&type=script&lang=ts"
export * from "./SingleLayerAttributesInfos.vue?vue&type=script&lang=ts"
import style0 from "./SingleLayerAttributesInfos.vue?vue&type=style&index=0&id=0e47df2d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e47df2d",
  null
  
)

export default component.exports